import React from "react";
import style from "./IconWithTooltip.module.css";
import PropTypes from "prop-types";
import {Tooltip} from "antd";

export const IconWithTooltip = ({icon, title}) => {

    return <Tooltip title={title}>{icon}</Tooltip>

}

IconWithTooltip.propTypes = {
    icon: PropTypes.any.isRequired,
    title: PropTypes.any.isRequired
}